export default {"src":"/_next/static/media/SNPO.66c7d238.svg","height":18,"width":18};